!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.pt = t());
}(this, function () {
  "use strict";

  return [{
    locale: "pt",
    pluralRuleFunction: function (e, t) {
      var o = String(e).split(".")[0];
      return t ? "other" : 0 == o || 1 == o ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "ano",
        relative: {
          0: "este ano",
          1: "próximo ano",
          "-1": "ano passado"
        },
        relativeTime: {
          future: {
            one: "em {0} ano",
            other: "em {0} anos"
          },
          past: {
            one: "há {0} ano",
            other: "há {0} anos"
          }
        }
      },
      "year-short": {
        displayName: "ano",
        relative: {
          0: "este ano",
          1: "próximo ano",
          "-1": "ano passado"
        },
        relativeTime: {
          future: {
            one: "em {0} ano",
            other: "em {0} anos"
          },
          past: {
            one: "há {0} ano",
            other: "há {0} anos"
          }
        }
      },
      month: {
        displayName: "mês",
        relative: {
          0: "este mês",
          1: "próximo mês",
          "-1": "mês passado"
        },
        relativeTime: {
          future: {
            one: "em {0} mês",
            other: "em {0} meses"
          },
          past: {
            one: "há {0} mês",
            other: "há {0} meses"
          }
        }
      },
      "month-short": {
        displayName: "mês",
        relative: {
          0: "este mês",
          1: "próximo mês",
          "-1": "mês passado"
        },
        relativeTime: {
          future: {
            one: "em {0} mês",
            other: "em {0} meses"
          },
          past: {
            one: "há {0} mês",
            other: "há {0} meses"
          }
        }
      },
      day: {
        displayName: "dia",
        relative: {
          0: "hoje",
          1: "amanhã",
          2: "depois de amanhã",
          "-2": "anteontem",
          "-1": "ontem"
        },
        relativeTime: {
          future: {
            one: "em {0} dia",
            other: "em {0} dias"
          },
          past: {
            one: "há {0} dia",
            other: "há {0} dias"
          }
        }
      },
      "day-short": {
        displayName: "dia",
        relative: {
          0: "hoje",
          1: "amanhã",
          2: "depois de amanhã",
          "-2": "anteontem",
          "-1": "ontem"
        },
        relativeTime: {
          future: {
            one: "em {0} dia",
            other: "em {0} dias"
          },
          past: {
            one: "há {0} dia",
            other: "há {0} dias"
          }
        }
      },
      hour: {
        displayName: "hora",
        relative: {
          0: "esta hora"
        },
        relativeTime: {
          future: {
            one: "em {0} hora",
            other: "em {0} horas"
          },
          past: {
            one: "há {0} hora",
            other: "há {0} horas"
          }
        }
      },
      "hour-short": {
        displayName: "h",
        relative: {
          0: "esta hora"
        },
        relativeTime: {
          future: {
            one: "em {0} h",
            other: "em {0} h"
          },
          past: {
            one: "há {0} h",
            other: "há {0} h"
          }
        }
      },
      minute: {
        displayName: "minuto",
        relative: {
          0: "este minuto"
        },
        relativeTime: {
          future: {
            one: "em {0} minuto",
            other: "em {0} minutos"
          },
          past: {
            one: "há {0} minuto",
            other: "há {0} minutos"
          }
        }
      },
      "minute-short": {
        displayName: "min.",
        relative: {
          0: "este minuto"
        },
        relativeTime: {
          future: {
            one: "em {0} min.",
            other: "em {0} min."
          },
          past: {
            one: "há {0} min.",
            other: "há {0} min."
          }
        }
      },
      second: {
        displayName: "segundo",
        relative: {
          0: "agora"
        },
        relativeTime: {
          future: {
            one: "em {0} segundo",
            other: "em {0} segundos"
          },
          past: {
            one: "há {0} segundo",
            other: "há {0} segundos"
          }
        }
      },
      "second-short": {
        displayName: "seg.",
        relative: {
          0: "agora"
        },
        relativeTime: {
          future: {
            one: "em {0} seg.",
            other: "em {0} seg."
          },
          past: {
            one: "há {0} seg.",
            other: "há {0} seg."
          }
        }
      }
    }
  }, {
    locale: "pt-AO",
    parentLocale: "pt-PT"
  }, {
    locale: "pt-PT",
    parentLocale: "pt",
    pluralRuleFunction: function (e, t) {
      var o = !String(e).split(".")[1];
      return t ? "other" : 1 == e && o ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "ano",
        relative: {
          0: "este ano",
          1: "próximo ano",
          "-1": "ano passado"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} ano",
            other: "dentro de {0} anos"
          },
          past: {
            one: "há {0} ano",
            other: "há {0} anos"
          }
        }
      },
      "year-short": {
        displayName: "ano",
        relative: {
          0: "este ano",
          1: "próximo ano",
          "-1": "ano passado"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} ano",
            other: "dentro de {0} anos"
          },
          past: {
            one: "há {0} ano",
            other: "há {0} anos"
          }
        }
      },
      month: {
        displayName: "mês",
        relative: {
          0: "este mês",
          1: "próximo mês",
          "-1": "mês passado"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} mês",
            other: "dentro de {0} meses"
          },
          past: {
            one: "há {0} mês",
            other: "há {0} meses"
          }
        }
      },
      "month-short": {
        displayName: "mês",
        relative: {
          0: "este mês",
          1: "próximo mês",
          "-1": "mês passado"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} mês",
            other: "dentro de {0} meses"
          },
          past: {
            one: "há {0} mês",
            other: "há {0} meses"
          }
        }
      },
      day: {
        displayName: "dia",
        relative: {
          0: "hoje",
          1: "amanhã",
          2: "depois de amanhã",
          "-2": "anteontem",
          "-1": "ontem"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} dia",
            other: "dentro de {0} dias"
          },
          past: {
            one: "há {0} dia",
            other: "há {0} dias"
          }
        }
      },
      "day-short": {
        displayName: "dia",
        relative: {
          0: "hoje",
          1: "amanhã",
          2: "depois de amanhã",
          "-2": "anteontem",
          "-1": "ontem"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} dia",
            other: "dentro de {0} dias"
          },
          past: {
            one: "há {0} dia",
            other: "há {0} dias"
          }
        }
      },
      hour: {
        displayName: "hora",
        relative: {
          0: "esta hora"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} hora",
            other: "dentro de {0} horas"
          },
          past: {
            one: "há {0} hora",
            other: "há {0} horas"
          }
        }
      },
      "hour-short": {
        displayName: "h",
        relative: {
          0: "esta hora"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} h",
            other: "dentro de {0} h"
          },
          past: {
            one: "há {0} h",
            other: "há {0} h"
          }
        }
      },
      minute: {
        displayName: "minuto",
        relative: {
          0: "este minuto"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} minuto",
            other: "dentro de {0} minutos"
          },
          past: {
            one: "há {0} minuto",
            other: "há {0} minutos"
          }
        }
      },
      "minute-short": {
        displayName: "min",
        relative: {
          0: "este minuto"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} min",
            other: "dentro de {0} min"
          },
          past: {
            one: "há {0} min",
            other: "há {0} min"
          }
        }
      },
      second: {
        displayName: "segundo",
        relative: {
          0: "agora"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} segundo",
            other: "dentro de {0} segundos"
          },
          past: {
            one: "há {0} segundo",
            other: "há {0} segundos"
          }
        }
      },
      "second-short": {
        displayName: "s",
        relative: {
          0: "agora"
        },
        relativeTime: {
          future: {
            one: "dentro de {0} s",
            other: "dentro de {0} s"
          },
          past: {
            one: "há {0} s",
            other: "há {0} s"
          }
        }
      }
    }
  }, {
    locale: "pt-CH",
    parentLocale: "pt-PT"
  }, {
    locale: "pt-CV",
    parentLocale: "pt-PT"
  }, {
    locale: "pt-GQ",
    parentLocale: "pt-PT"
  }, {
    locale: "pt-GW",
    parentLocale: "pt-PT"
  }, {
    locale: "pt-LU",
    parentLocale: "pt-PT"
  }, {
    locale: "pt-MO",
    parentLocale: "pt-PT"
  }, {
    locale: "pt-MZ",
    parentLocale: "pt-PT"
  }, {
    locale: "pt-ST",
    parentLocale: "pt-PT"
  }, {
    locale: "pt-TL",
    parentLocale: "pt-PT"
  }];
});